.<template>
    <div>
       <div class="table-wrap">
        <el-table size="small" :data="workerlist" border style="width: 100%" >
        <el-table-column type="index" label="">
          </el-table-column>
          <el-table-column prop="username" label="ID">
          </el-table-column>
          <el-table-column prop="lat" label="经度">
          </el-table-column>
          <el-table-column prop="lng" label="纬度">
          </el-table-column>
          <el-table-column prop="address" label="地址">
          </el-table-column>
          <el-table-column prop="update_time" label="时间">
          </el-table-column>
          <el-table-column prop="sos_url" label="录音文件" width="400">
            <template slot-scope="scope">
                 <audio
                    :src="scope.row.sos"
                    controls="controls"
                    ref="audio"
                >Your browser does not support the audio element.</audio> 
                <span v-if="!scope.row.sos" style="color: #c1c2c3;">(暂无)</span>
            </template>
          </el-table-column>
          <el-table-column prop="username" label="技师姓名">
             <!-- <template slot-scope="scope">
               <span>{{scope.row}}</span>
            </template> -->
          </el-table-column>
          <el-table-column prop="mobile" label="联系方式">
          </el-table-column>
          <el-table-column  label="操作">
            <template slot-scope="scope">
                     <el-button  type="danger" @click="deleteitem(scope.row.user_id)" round >删除</el-button>
               
            </template>
          </el-table-column>
        </el-table>
           <!--分页-->
                <div class="pagination">
                    <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="getworker.page"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="getworker.rows"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
                </el-pagination>
                </div>
      </div>
       <el-dialog title="录音播放" :visible.sync="dialogVisible" width="20%" :before-close="stop">
      <template>
        <center>
          <audio
            :src="src"
            autoplay="autoplay"
            controls="controls"
            ref="audio"
          >Your browser does not support the audio element.</audio>
        </center>
      </template>
    </el-dialog>
    </div>
</template>

<script>
import request from '@/utils/request'
export default{
    data() {
        return{
            total: 0,
            src: "",
      dialogVisible: false,
            total: 0,
            getworker: {
                page: 1,
                rows: 10
            },
            workerlist: []
        }
    },
    created() {
        this.getTableList()
    },
    methods: {
        handleSizeChange(e) {
            this.getworker.page = e
            this.getTableList
        },
        handleCurrentChange() {
            this.getworker.rows = e
            this.getTableList
        },
         //播放组件
    handlePlay(row) {
        
      this.src = row.filePath;
      this.play();
    },
    //播放
    play() {
      this.dialogVisible = true;
      this.$refs.audio.play();
    },
    //音频暂停
    stop() {
      this.dialogVisible = false;
      this.$refs.audio.pause();
      this.$refs.audio.currentTime = 0;
    },
        deleteitem(id) {
            let that = this
            this.$confirm("此操作将不可恢复, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
      }).then(() => {
        request._post('/shop/waiter.user/delSos', {
            user_id: id
        }).then(res=> {
            if ( res.code == 1) {
                that.getTableList()
                  this.$message({
            type: 'success',
            message: '删除成功!'
          });
          that.getTableList()
            }else {
                this.$message({
            type: 'info',
            message: '删除失败'
          }); 
            }
        })
        //   this.$message({
        //     type: 'success',
        //     message: '删除成功!'
        //   });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });  
        })
        },
        getTableList() {
            let that = this;
            request._get('/shop/waiter.user/sosList', this.getworker).then(res => {
            console.log(res, 121);
            that.workerlist = res.data.data
            that.total = res.data.total
            })
        
      }
    }
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/views/supplier/warninginfo/index.vue